<section class="c-cover c-cover--basic t-flag-grupo-c3" id="inicio">

  <div class="c-cover__image">
    <!-- <red-marathon-logo class="logo"></red-marathon-logo> -->
    <img src="assets/images/maratona-2024/logo-maratona2024.png"
         alt="logo maratona redação nota 1000"
         class="logo">
  </div>

  <h1 class="c-cover__main-title omega">
    Regulamento Maratona 2024
  </h1>

  <div class="c-cover__content">
    <!--    Última atualização: 28 de setembro de 2021-->

    <ol class="o-list-ordered o-list-ordered--no-indent">
      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA CAMPANHA</h2>

        <p class="u-margin-bottom">
          São participantes desta Campanha, única e exclusivamente, alunos de escolas contratantes da Plataforma e alunos
          de pacotes individuais cadastrados na plataforma Redação Nota 1000 que enviarem redações do tema oficial
          disponibilizado e divulgado pela plataforma para cada etapa, respeitando os prazos estabelecidos para cada
          uma delas.
        </p>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            São participantes desta Campanha, única e exclusivamente,
            alunos de escolas contratantes da Plataforma e alunos de pacotes
            individuais cadastrados na plataforma Redação Nota 1000.
          </li>

          <li class="o-list-ordered__item">
            Período de Vigência: Esta Campanha tem início no dia 15/05/2024, às 00h00 e se encerra no dia 30/09/2024,
            às 23:59 (horário de Brasília)

            <p class="u-margin-top">
              <strong>Etapa 1:</strong> Início no dia 15/05/2024, às 00h00 e encerramento no dia 30/06/2024,
              às 23:59 (horário de Brasília). O resultado da etapa será divulgado até dia 15/07/2024,
              às 18h00 na plataforma do Redação Nota 1000
            </p>

            <p>
              <strong>Etapa 2:</strong> início no dia 15/08/2024, às 00h00 e encerramento no dia 30/09/2024,
              às 23:59 (horário de Brasília). O resultado da etapa será divulgado até dia 15/10/2024, às 18h00
              na plataforma do Redação Nota 1000.
            </p>
          </li>

          <li class="o-list-ordered__item">
            As escolas poderão concorrer em três categorias da Maratona, sendo elas:

            <ol class="o-list-ordered u-margin-top">
              <li class="o-list-ordered__item">
                Ensino Fundamental II – Para contabilização da premiação, serão consideradas apenas correções das
                redações feitas por alunos do 9º ano do E.F. II. Outros segmentos poderão participar e aparecerão
                no ranking, porém não serão contabilizados para premiação.
              </li>

              <li class="o-list-ordered__item">
                Ensino Médio - Para contabilização da premiação, serão consideradas apenas correções das redações feitas
                por alunos do Ensino Médio e de Pré-Vestibular. Outros segmentos poderão participar e aparecerão
                no ranking, porém não serão contabilizados para premiação.
              </li>

              <li class="o-list-ordered__item">
                Engajamento das Escolas participantes – Para contabilização da premiação, o número de redações enviadas
                será dividido pelo número de créditos totais da escola que poderiam ser empenhados na maratona.
              </li>
            </ol>

          </li>

          <li class="o-list-ordered__item">
            As escolas poderão participar das 3 categorias. No entanto, para análise da categoria de engajamento (1.3.3),
            as escolas que ganharem um ou mais prêmios nas outras categorias (1.3.1 e/ou 1.3.2) não serão elegíveis.
            Desse modo, será possível distribuirmos as premiações para o maior número de escolas possível, valorizando,
            na terceira categoria, mais o engajamento em si do que o resultado das notas dos alunos.
          </li>
        </ol>

      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA DINÂMICA</h2>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            A participação na Maratona só se confirmará mediante o envio de textos nas duas etapas, nos períodos
            vigentes, com temas propostos pela Redação Nota 1000 e com o uso de créditos dos pacotes adquiridos.
          </li>

          <li class="o-list-ordered__item">
            Para ser elegível em cada etapa, a escola deverá:

            <ol class="o-list-ordered u-margin-top">
              <li class="o-list-ordered__item">
                criar a tarefa no link
                <a href="https://portal.redacaonota1000.com.br/home" target="_blank">https://portal.redacaonota1000.com.br/home</a>,
                com o login e senha de uso na Plataforma;
              </li>

              <li class="o-list-ordered__item">
                para a maratona de E.M.: enviar redações de pelo menos 30% dos alunos cadastrados nas turmas de
                Ensino Médio e pré-vestibular da instituição. Caso a porcentagem de 30% corresponda a menos
                de 20 estudantes, a escola somente será elegível se enviar redações de pelo menos 20 alunos diferentes.
              </li>

              <li class="o-list-ordered__item">
                para a maratona de E.F. II: enviar redações de pelo menos 30% dos alunos cadastrados nas turmas
                de 9º ano do E.F. II da instituição. Caso a porcentagem de 30% corresponda a menos de 20 estudantes,
                a escola somente será elegível se enviar redações de pelo menos 20 alunos diferentes.<br><br>

                <strong>Exemplo:</strong> Em uma escola com 50 alunos, a porcentagem de 30% será equivalente a menos
                de 20 estudantes. Desse modo, para que a instituição seja elegível, será necessário que, no mínimo,
                20 desses 50 alunos submetam seus textos à plataforma, considerando, também, os temas e prazos propostos.
                Nesse sentido, escolas que não tenham o mínimo de 20 alunos cadastrados na categoria não estarão aptas
                a participar da Maratona.
              </li>
            </ol>

          </li>

          <li class="o-list-ordered__item">
            Para ser elegível no ranking de engajamento, é necessário que a escola envie pelo menos 60 redações,
            somando as duas etapas.
          </li>
        </ol>
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DOS CRITÉRIOS DE AVALIAÇÄO</h2>

        <p>
          Participarão nesta Maratona todas as redações enviadas seguindo as regras estipuladas nas categorias
          de premiação.
        </p>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            Critério de avaliação do Ensino Fundamental e Ensino Médio (itens 1.3.1. e 1.3.2.): as correções para
            Ensino Fundamental seguirão os critérios de correção do gênero textual Artigo de Opinião, e as de
            Ensino Médio seguirão as diretrizes do modelo de correção Enem, ambos já utilizados na Plataforma
            Redação Nota 1000.

            <ol class="o-list-ordered u-margin-top-small">
              <li class="o-list-ordered__item">
                Caso o aluno faça mais de uma redação na mesma etapa, será considerada como elegível a correção com
                a maior nota;
              </li>

              <li class="o-list-ordered__item">
                A média final de cada instituição participante será calculada considerando todas as correções elegíveis
                nas 2 etapas da Maratona no prazo definido.
              </li>

              <li class="o-list-ordered__item">
                Detalhamento do cálculo para a premiação: Para a categoria de correção do Ensino Fundamental e do
                Ensino Médio, serão calculadas as médias das notas de todas as redações elegíveis que cumprirem
                as regras determinadas;
              </li>

              <li class="o-list-ordered__item">
                Critério de desempate entre alunos: Ordem de envio, em que a redação elegível enviada antes terá
                melhor classificação.
              </li>

              <li class="o-list-ordered__item">
                Critério de desempate entre escolas: A escola que tiver mais alunos participantes na etapa,
                terá melhor classificação.
              </li>
            </ol>
          </li>

          <li class="o-list-ordered__item">
            Critério de avaliação para premiação de Engajamento das escolas (item 1.3.3.): Para a categoria
            de engajamento de escola, será calculada a divisão do número de redações elegíveis realizadas pelos alunos
            pelo número total de alunos cadastrados de 9° ano do F.II a pré-vestibular. Nesse cálculo,
            serão consideradas tanto as redações do Ensino Médio quanto as redações do Fundamental, somadas.
            Exemplo: se a escola tem 500 alunos elegíveis às propostas da maratona e realizou 750 redações elegíveis
            nas duas etapas da maratona, seu engajamento será de 750 / (500 x 2 etapas) = 750/1000 = 75%

            <ol class="o-list-ordered u-margin-top-small">
              <li class="o-list-ordered__item">
                Critério de desempate entre as escolas mais engajadas: se duas
                escolas resultarem no mesmo percentual de engajamento,
                o desempate se dará pelo número total de redações realizadas
                (numerador da equação acima). Se, ainda assim, o empate persistir,
                será considerado a maior quantidade de redações realizadas
                pelo EM (Ensino Médio).
              </li>
            </ol>
          </li>

          <li class="o-list-ordered__item">
            É obrigatório o uso dos créditos para correção de redações com nossos corretores especializados
            Redação Nota 1000.
          </li>

          <li class="o-list-ordered__item">
            Todas as redações dos participantes da Maratona serão corrigidas por corretores da Redação Nota 1000.
            Propostas temáticas corrigidas pelos professores da própria escola não serão contabilizadas na Maratona.
          </li>

          <li class="o-list-ordered__item">
            Serão desconsideradas para contabilização na Maratona todas as redações que não forem enviadas no período
            da etapa vigente e/ou que forem corrigidas por avaliadores fora da equipe Redação Nota 1000.
          </li>

          <li class="o-list-ordered__item">
            Com o objetivo de proporcionar as mesmas condições de participação e os mesmos parâmetros de avaliação
            a todos os alunos, em tarefas elaboradas a partir dos temas da Maratona, o cadastro de quaisquer
            orientações específicas para correção será vetado. Essa restrição se aplica a todas as tarefas
            em que esses temas sejam selecionados, inclusive às criadas por instituições que não atendem
            aos critérios de elegibilidade para participar da Maratona. Em caso de descumprimento de qualquer
            uma das diretrizes, a escola poderá ser desclassificada.
          </li>

          <li class="o-list-ordered__item">
            A única nota que valerá para avaliação e elegibilidade de participação na Maratona
            é a realizada pela equipe de corretores da Redação Nota 1000.
          </li>
        </ol>
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA PREMIAÇÃO</h2>

        <p>
          Serão premiadas as três melhores escolas nas três categorias citadas na cláusula 1.3, sendo o ranking com
          três posições (1º, 2º e 3º lugar). Para as escolas ganhadoras, será entregue um troféu informando a posição,
          ressalvado o disposto na cláusula 1.4.
        </p>
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DAS DISPOSIÇÕES GERAIS</h2>

        <p>
          A Maratona será divulgada através de meios de mídia e comunicação, nas plataformas próprias, do Plurall
          e escolas parceiras.
        </p>

        <p>
          Caso participe da maratona, a instituição autoriza a Redação Nota 1000 a publicar em sua página nome
          da escola, o estado e o nome do(a) aluno(a) no Quadro de Honra das melhores notas, em caso de classificação
          entre os 10 primeiros colocados.
        </p>

        <p>
          A Plataforma assume que, ao enviar redações para a “Campanha Maratona Redação Nota 1000 – 2024",
          as instituições indicam conhecimento prévio das regras contidas neste Regulamento e a aceitação plena
          de seus termos e condições.
        </p>
      </li>

    </ol>

    <h3>TREINE, PARTICIPE E SEJA UM ALUNO NOTA 1000!</h3>

  </div>

</section>
